import { render, staticRenderFns } from "./rejected-orders.vue?vue&type=template&id=c42c1fc2&"
import script from "./rejected-orders.vue?vue&type=script&lang=js&"
export * from "./rejected-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports